<script>
    import {Menu} from 'vue-burger-menu';
    import {logout} from '@/services/Authentication';
    import { mapGetters } from 'vuex';

    export default {
        name: 'AppMenu',
        components: {
            Menu,
        },
        data() {
            return {
                isMenuOpen: false,
            };
        },
        methods: {
            handleMenuButtonClick() {
                this.isMenuOpen = !this.isMenuOpen;
            },
            logOutOfApp() {
                logout();
            },
            isRouteActive(route) {
                if (this.$router.currentRoute.path === route) {
                    return true;
                }
                return false;
            },
        },
        computed: {
            ...mapGetters({
                isPremium: 'isPremium'
            })
        },
    };
</script>

<template>
    <div class="menu-container">
        <div class="side-menu" :class="{'side-menu-closed' : !isMenuOpen}">
        <Menu
                :width="'340'"
                :burgerIcon="false"
                :isOpen="isMenuOpen"
                @closeMenu="isMenuOpen = false"
        >
            <router-link v-if="isMenuOpen" class="tile-navigation" :to="'/'">
                <img
                        v-if="isRouteActive('/')"
                        src="@/assets/starface_icons_png/24/orange/dashboard_24.png"
                        alt="Dashboard"
                >
                <img v-else src="@/assets/starface_icons_png/24/grey/dashboard_24.png" alt="Dashboard">
                <span>Dashboard</span>
            </router-link>
            <router-link v-if="isMenuOpen" class="tile-navigation" :to="'/users'">
                <img
                        v-if="isRouteActive('/users')"
                        src="@/assets/starface_icons_png/24/orange/outline_24.png"
                        alt="Benutzer"
                >
                <img v-else src="@/assets/starface_icons_png/24/grey/outline_24.png" alt="Benutzer">
                <span>Benutzer</span>
            </router-link>
            <router-link v-if="isMenuOpen" class="tile-navigation" :to="'/phone-numbers'">
                <img
                        v-if="isRouteActive('/phone-numbers')"
                        src="@/assets/starface_icons_png/24/orange/numbers_24.png"
                        alt="Rufnummer"
                >
                <img v-else src="@/assets/starface_icons_png/24/grey/numbers_24.png" alt="Rufnummer">
                <span>Rufnummer</span>
            </router-link>
            <router-link v-if="isMenuOpen" class="tile-navigation" :to="'/groups'">
                <img
                        v-if="isRouteActive('/groups')"
                        src="@/assets/starface_icons_png/24/orange/teams_24.png"
                        alt="Gruppen & Hotline"
                >
                <img v-else src="@/assets/starface_icons_png/24/grey/teams_24.png" alt="Gruppen & Hotline">
                <span>Gruppen & Hotline</span>
            </router-link>
            <span class="line"></span>
            <router-link v-if="isMenuOpen" class="tile-navigation" :to="'/conference'">
                <img
                        v-if="isRouteActive('/conference')"
                        src="@/assets/starface_icons_png/24/orange/conference_24.png"
                        alt="Telefonkonferenz konfigurieren"
                >
                <img
                        v-else
                        src="@/assets/starface_icons_png/24/grey/conference_24.png"
                        alt="Telefonkonferenz konfigurieren"
                >
                <span>Telefonkonferenz konfigurieren</span>
            </router-link>
            <router-link v-if="isMenuOpen" :class="{ disabled: !isPremium }" class="tile-navigation" :to="'/address-book'">
                <img
                        v-if="isRouteActive('/address-book')"
                        src="@/assets/starface_icons_png/24/orange/invoice_24.png"
                        alt="Adressbuch importieren"
                >
                <img
                        v-else
                        src="@/assets/starface_icons_png/24/grey/invoice_24.png"
                        alt="Adressbuch importieren"
                >
                <span>Adressbuch importieren</span>
            </router-link>
            <router-link v-if="isMenuOpen" :class="{ disabled: !isPremium }" class="tile-navigation" :to="'/fax'">
                <img
                        v-if="isRouteActive('/fax')"
                        src="@/assets/starface_icons_png/24/orange/fax_24.png"
                        alt="Fax konfigurieren"
                >
                <img v-else src="@/assets/starface_icons_png/24/grey/fax_24.png" alt="Fax konfigurieren">
                <span>Fax konfigurieren</span>
            </router-link>
            <span class="line"></span>
            <router-link v-if="isMenuOpen" class="tile-navigation" :to="'/account'">
                <img
                        v-if="isRouteActive('/account')"
                        src="@/assets/starface_icons_png/24/orange/stammdaten_24.png"
                        alt="Stammdaten"
                >
                <img v-else src="@/assets/starface_icons_png/24/grey/stammdaten_24.png" alt="Stammdaten">
                <span>Stammdaten</span>
            </router-link>
            <router-link v-if="isMenuOpen" class="tile-navigation" :to="'/calls-overview'">
                <img
                        v-if="isRouteActive('/calls-overview')"
                        src="@/assets/starface_icons_png/24/orange/call list_24.png"
                        alt="Gesprächsübersicht"
                >
                <img
                        v-else
                        src="@/assets/starface_icons_png/24/grey/calllist_24.png"
                        alt="Gesprächsübersicht"
                >
                <span>Gesprächsübersicht</span>
            </router-link>
            <router-link v-if="isMenuOpen" class="tile-navigation" :to="'/invoices'">
                <img
                        v-if="isRouteActive('/invoices')"
                        src="@/assets/starface_icons_png/24/orange/invoice_24.png"
                        alt="Rechnungen"
                >
                <img v-else src="@/assets/starface_icons_png/24/grey/invoice_24.png" alt="Rechnungen">
                <span>Rechnungen</span>
            </router-link>
            <span class="line"></span>
            <!--        
            <router-link v-if="isMenuOpen" class="tile-navigation" :to="'/phone-numbers-order'">
                <img
                        v-if="isRouteActive('/phone-numbers-order')"
                        src="@/assets/starface_icons_png/24/orange/add number_24.png"
                        alt="Rufnummer bestellen"
                >
                <img v-else src="@/assets/starface_icons_png/24/grey/addNumber_24.png" alt="Rufnummer bestellen">
                <span>Rufnummer bestellen</span>
            </router-link>
            -->
            <router-link v-if="isMenuOpen" :class="{ disabled: !isPremium }" class="tile-navigation" :to="'/rates'">
                <img
                        v-if="isRouteActive('/rates')"
                        src="@/assets/starface_icons_png/24/orange/tarif_24.png"
                        alt="Telefontarife"
                >
                <img v-else src="@/assets/starface_icons_png/24/grey/tarif_24.png" alt="Telefontarife">
                <span>Telefontarife</span>
            </router-link>
            <router-link v-if="isMenuOpen" class="tile-navigation" :to="'/download-app'">
                <img
                        v-if="isRouteActive('/download-app')"
                        src="@/assets/starface_icons_png/24/orange/download_24.png"
                        alt="Download App"
                >
                <img v-else src="@/assets/starface_icons_png/24/grey/download_24.png" alt="Download App">
                <span>Download App</span>
            </router-link>
            <router-link v-if="isMenuOpen" class="tile-navigation" :to="'/support'">
                <img
                        v-if="isRouteActive('/support')"
                        src="@/assets/starface_icons_png/24/orange/support_24.png"
                        alt="Support"
                >
                <img v-else src="@/assets/starface_icons_png/24/grey/support_24.png" alt="Support">
                <span>Support</span>
            </router-link>
            <router-link
                    v-if="isMenuOpen"
                    class="tile-navigation"
                    :to="'/login'"
                    @click.native="logOutOfApp"
            >
                <img src="@/assets/starface_icons_png/24/grey/logout.png" alt="Support">
                <span>Logout</span>
            </router-link>
        </Menu>
        <img
                class="menu-icon"
                src="@/assets/starface_icons_png/24/orange/hamburger_24.png"
                alt="Logo Starface"
                @click.stop="handleMenuButtonClick"
        >
        </div>
        <div class="backdrop" v-if="isMenuOpen" v-on:click="isMenuOpen = false"></div>
        <span class="menu-title">Menü</span>
    </div>
</template>

<style lang="scss" scoped>
    @import "../assets/scss/variables.scss";

    .menu-container{
        display: grid;

        .side-menu {
            position: relative;
            grid-column: 1 / span 1;
            grid-row: 1;
            -ms-grid-column: 1;
            -ms-grid-row: 1;
            height: 100%;

            justify-self: start;

            .tile-navigation {
                &.disabled {
                    opacity: 0.4;
                    cursor: default;
                    pointer-events: none;
                }
            }

            .menu-icon {
                width: 24px;
                height: 24px;
                cursor: pointer;
            }

            .line {
                width: 100%;
                height: 2px;
                padding: 0;
                margin: 5px 0 5px 24px;
                background-color: $grey-bright;
            }

            &.side-menu-closed {
                /deep/ .bm-menu {
                    overflow-y: hidden;
                }
            }

            /deep/ .bm-menu {
                position: absolute;
                height: 100vh;
                background-color: #fff;
                box-shadow: 10px 0 45px 0 $tile-shadow;
                top: -20px;
                left: -20px;


                .router-link-exact-active {
                    border-left: 4px solid $orange;
                    padding-left: 20px;

                    span {
                        color: $orange;
                    }
                }

                .cross-style {
                    left: 34px;
                    top: 24px;

                    & > .bm-cross {
                        min-height: 100%;
                        width: 1px !important;
                        height: 100% !important;
                        background-color: $orange;
                    }
                }
            }

            /deep/ .bm-item-list {
                display: block;
                height: 100%;
                margin-left: 0;
                font-size: 18px;
                overflow-y: auto;
                overflow-x: hidden;
                touch-action: manipulation;
                padding-bottom: 70px;

                img {
                    width: 24px;
                }

                & > * {
                    padding-left: 24px;
                    width: 340px;
                }

                & > * > span {
                    color: $text;
                    font-weight: normal;
                }
            }
        }

        .backdrop {
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            height: 100%;
            width: 100%;
            z-index: 8;
            overflow: hidden;
            -webkit-overflow-scrolling: touch;
        }

        .menu-title {
            padding-left: 8px;
            grid-column: 2 / span 1;
            grid-row: 1;
            line-height: 24px;
            letter-spacing: 0;
        }
    }

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        .menu-container{
            .menu-title{
                display: none;
            }
        }
    }
</style>
å
